module.exports = __webpack_public_path__ + "static/media/defaultImage.3a9dd231.png";